export enum CampaignProgressStatus {
  NotStarted = 'not_started',
  Sent = 'sent',
  Delivered = 'delivered',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
}

export enum CampaignStatus {
  Active = 'active',
  Inactive = 'inactive',
}
